<template>
  <div>
    <backButton></backButton>
    Storage Page
  </div>
</template>
<script>
import backButton from "../components/backButton.vue";
export default {
  components: {
    backButton: backButton,
  },
  methods: {},
};
</script>
<style lang="scss"></style>
